<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <AccessPrivilegeTable />
      </b-col><!--/.col-->
    </b-row><!--/.row-->
  </div>

</template>

<script>
  import AccessPrivilegeTable from './AccessPrivilegeTable.vue'

  export default {
    name: 'access-privilege',
    components: {AccessPrivilegeTable}
  }
</script>



// WEBPACK FOOTER //
// src/views/accessPrivilege/AccessPrivilege.vue